import React, { useState } from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import { API_URL } from "..";
import CustomerTable from "../components/CustomerTable";

const CustomerPage = () => {
    const [data,setData] = useState([]);
    const fetchUser  = async () =>{
        let headerList = {
            Accept: "*/*",
            "Content-type": "application/json",
          };
          const response = await fetch(
            API_URL+`/api/customer/fetch`,
            { method: "GET", headers: headerList }
          );
          const dataFor = await response.json();
          if (response.status === 201) {
              console.log(dataFor.customer)
              setData(dataFor.customer)
            
          }
    }   
    React.useEffect(()=>{
        fetchUser()
    },[1])
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Customers" />

        {/* TableDataLayer */}
        {
            data.length === 0? null :
        <CustomerTable  data={data}/>
        }

      </MasterLayout>

    </>
  );
};

export default CustomerPage; 
